import { getRuntimeGlobalState } from "./conversationRuntimeService";
function getGlobalState() {
    return getRuntimeGlobalState();
}
class SettingsService {
    constructor() {
        this.excelListeners = new Set();
        this.modelListeners = new Set();
    }
    getExcelExportSettings() {
        return getGlobalState().getExcelExportSettings();
    }
    getEditMode() {
        return this.getExcelExportSettings().editMode;
    }
    getDefaultBlackAndWhite() {
        return this.getExcelExportSettings().defaultBlackAndWhite;
    }
    getDefaultCollapseGroups() {
        return this.getExcelExportSettings().defaultCollapseGroups;
    }
    async updateExcelExportSettings(updates) {
        await getGlobalState().updateExcelExportSettings(updates);
        this.notifyExcelListeners();
    }
    async setEditMode(mode) {
        await this.updateExcelExportSettings({ editMode: mode });
    }
    async setDefaultBlackAndWhite(enabled) {
        await this.updateExcelExportSettings({ defaultBlackAndWhite: enabled });
    }
    async setDefaultCollapseGroups(enabled) {
        await this.updateExcelExportSettings({ defaultCollapseGroups: enabled });
    }
    async setDefaultClearComments(enabled) {
        await this.updateExcelExportSettings({ defaultClearComments: enabled });
    }
    getModelSettings() {
        return getGlobalState().getModelSettings();
    }
    getChatModel() {
        return this.getModelSettings().chatModel;
    }
    getReasoningMode() {
        return this.getModelSettings().reasoningMode;
    }
    async updateModelSettings(updates) {
        await getGlobalState().updateModelSettings(updates);
        this.notifyModelListeners();
    }
    async setChatModel(model) {
        await this.updateModelSettings({ chatModel: model });
    }
    async setReasoningMode(mode) {
        await this.updateModelSettings({ reasoningMode: mode });
    }
    getGeneralSettings() {
        return getGlobalState().getGeneralSettings();
    }
    getConversationRetentionDays() {
        return this.getGeneralSettings().conversationRetentionDays;
    }
    getLiveSlideIndexingEnabled() {
        return this.getGeneralSettings().liveSlideIndexingEnabled ?? true;
    }
    async updateGeneralSettings(updates) {
        await getGlobalState().updateGeneralSettings(updates);
    }
    async setConversationRetentionDays(days) {
        const clampedDays = Math.max(1, Math.min(14, days));
        await this.updateGeneralSettings({ conversationRetentionDays: clampedDays });
    }
    async setLiveSlideIndexingEnabled(enabled) {
        await this.updateGeneralSettings({ liveSlideIndexingEnabled: enabled });
    }
    subscribe(listener) {
        this.excelListeners.add(listener);
        return () => {
            this.excelListeners.delete(listener);
        };
    }
    subscribeToModelSettings(listener) {
        this.modelListeners.add(listener);
        return () => {
            this.modelListeners.delete(listener);
        };
    }
    notifyExcelListeners() {
        const current = this.getExcelExportSettings();
        this.excelListeners.forEach((listener) => {
            try {
                listener(current);
            }
            catch (error) {
                console.error("[SettingsService] Excel listener error:", error);
            }
        });
    }
    notifyModelListeners() {
        const current = this.getModelSettings();
        this.modelListeners.forEach((listener) => {
            try {
                listener(current);
            }
            catch (error) {
                console.error("[SettingsService] Model listener error:", error);
            }
        });
    }
}
export const settingsService = new SettingsService();
export default settingsService;
